const utils = require("frontend-controller/lib/utils")
module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		preventSortOfField: {},
		buttonContext: 'trip',
		showHead: false,
		showInsertButton: false,
		inline: true
	},

	methods: {
		onBuild: function(storage){
			if(storage.isClient){
				const controller = getComponent('artCrmController')
				if(((controller || {}).model || {}).tripTableShouldWaitForExternalFilters){
					this.model.waitForExternalFilters = true
					controller.model.tripTableShouldWaitForExternalFilters = false
				}
			}
		},

		loadResourcesGranted: function(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
			var nrOfFilters = utils.collectionSize((resourceFilters || {}).filters)
			return actionKey !== 'refreshResources' || nrOfFilters > 3 || (nrOfFilters > 0 && !this.model.waitForExternalFilters);
		},

		onResourceSanitized: function(){
			this.model.waitForExternalFilters = false
		},

		showInsert: function(){
			return getComponent('artCrmController').showInsert('trip');
		},

		showEdit: function(tripID, tripData){
			if(((this.model.controller || {}).config || {}).usage === 'selection'){
				return this.triggerClosest('onDecision', {
					decisionType: 'tripSelected',
					decisionComponent: this,
					tripID,
					tripData
				});
			}
			return getComponent('artCrmController').showEdit('trip', tripID, tripData);
		},

		addEntity: function(entity){
			if(this.config.isReady && this.model.$table){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }))
			}
		},
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(!self.model.controller){
				self.closest('templates_artCrm_entity_controller', function(controller){
					self.model.controller = controller
				});
			}

			self.model.$table = $element.find('table');
		}
	},

	handlers: [{
		name: 'recordControllerResourcesModified',
		handle: function(callerComponent) {
			if((
				callerComponent.config.entityContext === 'address' ||
				callerComponent.config.entityContext === 'trip'
			) && this.config.isReady){
				this.refreshData();
			}
		}
	}]
}